import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "../../../components/general/button/Button";
import "../../../assets/css/customer/business/cta/CTA.css";
import { useNavigate } from "react-router-dom";
const CTA = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px",
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const handleRegister = () => {
    navigate("/role-select");
  };
  return (
    <section
      ref={sectionRef}
      className={`cta-section ${isVisible ? "animate-in" : ""}`}
    >
      <Container>
        <Row className="align-items-center g-4">
          <Col lg={8} md={7}>
            <h2 className="cta-heading">Ready to Boost Your Business?</h2>
            <p className="cta-text">
              Thousands of potential customers are looking for great deals in
              your area. By joining the KisaanMart platform, you can reach these
              customers and grow your business effortlessly.
            </p>
          </Col>
          <Col lg={4} md={5} className="text-md-end text-center">
            <Button
              variant="gradient"
              size="large"
              className="cta-button"
              onClick={handleRegister}
            >
              Register Now
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CTA;
